<template>
  <v-dialog :value="isPopupDGNL" max-width="800" persistent>
    <v-card class="text-center quick-view">
      <v-card-title class="text-sm-left font-weight-bold px-5">
        Thi thử - Đánh giá năng lực
        <v-spacer />
        <v-icon aria-label="Close" @click="closeModal">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="px-9 pt-0">
        <v-data-table
          :headers="headers"
          :items="dataDGNL"
          item-key="id"
          disable-sort
          class="custom-table"
        >
          <template v-slot:no-data>Không có dữ liệu</template>
          <template v-slot:item.content="{ item }">
            <div class="d-flex align-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    @click="getUrlTest(item.exam_batch_id,item.user_id)"
                    :size="size"
                    :color="color"
                    >mdi-file-edit-outline</v-icon
                  >
                </template>
                <span>Kết quả chi tiết</span>
              </v-tooltip>
              <span class="btn-detail ml-3">{{ item.content }}</span>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import RepositoryFactory from '../../../repositories/RepositoryFactory';
const ExamRepository = RepositoryFactory.get('exam');

export default {
  props: {
    dataDGNL: {
      type: Array,
      default: () => [],
    },
    isPopupDGNL: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      headers: [
        { text: "Tên con", value: "customerName", align: "center" },
        { text: "Thời gian", value: "createdAt", align: "center" },
        { text: "Log", value: "content", align: "center", width: 200 },
      ],
    };
  },
  methods: {
    closeModal() {
      this.$emit("closeModal", false);
    },
    async getUrlTest(batchId, userId) {
      let res = await ExamRepository.getLinkDetailDGNL(batchId, userId);
      if(res.success && res.data.link) {
        window.open(res.data.link, '_blank');
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Không tìm thấy kết quả chi tiết',
        })
      }
    },
  },
};
</script>
<style lang="scss">
.get-url {
  cursor: pointer;
}
.custom-table th span {
  font-size: 14px;
  font-weight: bold;
}
</style>
